import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/patient",
  patientsList: [],
  totalPatients: 0
}

const getters = {
  PatientsList: (state) => state.patientsList,
  totalPatients: (state) => state.totalPatients
}

const mutations = {
  setPatients(state, patients) {
    state.patientsList = patients
  },
  setTotalPatients(state, total) {
    state.totalPatients = total
  }
}

const actions = {
  async listAllPatients({ commit }, { offset = 0, limit = 10, search = null, orgId = null } = {}) {
    try {
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: { offset, limit, search, detailed: true, orgId }
      }
      const response = await window.axios.get(url, config)
      commit("setPatients", response.data.patients)
      commit("setTotalPatients", response.data.total)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listPatientMedicalRecords({ commit }, { patientId, mode = "patient" }) {
    try {
      const url = `${process.env.VUE_APP_URL}/medhist/${mode}/${patientId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listPatientFamilyHistory({ commit }, { patientId, mode = "patient" }) {
    try {
      const url = `${process.env.VUE_APP_URL}/famhist/${mode}/${patientId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listPatientById({ commit }, { patientId, usePersonId }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/patientById/${userId}/${patientId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: {
          detailed: true,
          usePersonId: usePersonId
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listPatientByPersonId({ commit }, { personId }) {
    try {
      //const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/person/${personId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: { detailed: true }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async removePatient({ commit }, { patientId }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${patientId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.delete(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async updatePatient({ commit }, { patientId, payload }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${patientId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.put(url, payload, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message)
      }

      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
